
import template from '../../../templates/checkout-flow/account.directive.tpl.html';

import app from '../../App';

export function accountDirective (ShippingAddressService,EmailValidatorService,Info,SaveQuoteService,PricingHelper) {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs ) => {
            scope.Info=Info;
            scope.emailValid=true;
            scope.addressErrorShow=false;
            scope.addressError='';
            scope.addressValidated=false;
            scope.$watch('data.accountInfo.email',(newValue, oldValue)=>{
                EmailValidatorService.validate(encodeURIComponent(newValue)).then(
                    (response)=>{
                        if(response.data.Success){
                            scope.emailValid=true;
                        }else{
                            scope.emailValid=false;
                        }
                        if(newValue == ''){
                            scope.emailValid=true;
                        }
                    },
                    (reject)=>{
                        // console.log(reject);
                    }
                );
            });
            scope.$watch('data.shippingAddressInfo.country', () => {
                scope.data.shippingAddressInfo.state='';
            },true);
            scope.submitAccountInfo = () => {
                if(scope.accountAddress.$valid && scope.data.pricingParams.devices>0) {
                    ShippingAddressService.validateAddress(scope.data.shippingAddressInfo, scope.data.accountInfo).then(
                        (response) => {
                            if (response.data.Success == true) {
                                scope.data.addressID = response.data.Result;
                                scope.addressErrorShow = false;
                                scope.addressValidated = true;
                                scope.data.step=3;
                            } else {
                                scope.addressError = response.data.ErrorMessage;
                                scope.addressErrorShow = true;
                                scope.addressValidated = false;
                            }
                        },
                        (reject) => {
                        }
                    );
                }
                if(scope.accountInfo.$valid && scope.data.pricingParams.devices==0){
                    scope.data.step=3;
                }
            };

            scope.showSaveQuote=false;
            scope.showSaveQuoteModal = () => {
                scope.showSaveQuote=true;
            };
            scope.hideSaveQuoteModal = () => {
                scope.showSaveQuote=false;
                scope.saveQuoteSended=false;
            };
            scope.saveQuoteSubmit = (form) => {
                let url= 'https://'+location.host+'/checkout/?step=2&displays='+scope.data.pricingParams.displays+'&devices='+scope.data.pricingParams.devices+'&plan='+scope.data.pricingParams.plan;
                if(scope.data.validatedPromocodes && scope.data.validatedPromocodes.length>0){
                    url+='&promocodes=';
                    scope.data.validatedPromocodes.forEach(function(item,index,arr){
                        if(index==0){
                            url+=item.PromoCode;
                        }else{
                            url+=','+item.PromoCode;
                        }
                    });
                }
                SaveQuoteService.saveQuote(scope.saveQuote.name,scope.saveQuote.email,scope.saveQuote.phone,url,scope.data.pricingParams.plan,scope.data.pricingParams.displays,scope.data.pricingParams.devices,Math.round((PricingHelper.getTotalLicense(scope.data.pricingParams.plan,scope.data.pricingParams.displays))* 100) / 100).then(
                    (response) => {
                        if(response.data.Success){
                            scope.saveQuoteSended=true;
                        }else{
                            console.log(response);
                        }
                    },
                    (reject) => {
                        console.log(reject);
                    }
                );
            };
        }
    };
};

app.directive( 'accountDirective',accountDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/account-directive.js